import {FC} from 'react';
import {styled} from 'styled-components';

import {LoadingIndicator} from '@shared_web/components/core/loading_indicator';

export const Loader: FC = () => {
  return (
    <Wrapper>
      <LoadingIndicator />
    </Wrapper>
  );
};

Loader.displayName = 'Loader';

const Wrapper = styled.div`
  display: flex;
  flex-grow: 1;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;
